import { ReactElement, ReactNode } from "react";

import PageHeader from "../pageHeader/PageHeader";

import styles from "./page-card.module.css";

const PageCard = ({
  showBackToHomeLink = false,
  largeTitle = false,
  title,
  subTitle,
  description,
  className,
  children,
}: {
  showBackToHomeLink?: boolean;
  largeTitle?: boolean;
  title: string;
  subTitle?: ReactElement;
  description?: string | ReactElement;
  className?: string;
  children: ReactNode;
}): ReactElement => {
  return (
    <section className={`${styles.card}${className ? ` ${className}` : ""}`}>
      <PageHeader
        title={title}
        subTitle={subTitle}
        description={description}
        showBackToHomeLink={showBackToHomeLink}
        largeTitle={largeTitle}
      />
      {children}
    </section>
  );
};

export default PageCard;
